<mat-card class="viewerholder">
    <div class="docheader">     
      <div class="name">{{ documentName }}</div>
      <div class="right_pannel">
        <div class="head">

          <ng-container *ngIf="showLocalPanel">

            <button mat-icon-button color="primary">
              <mat-icon>cloud_download</mat-icon>
            </button>
            <button mat-icon-button color="primary">
              <mat-icon>share</mat-icon>
            </button>

          </ng-container>
          
          <button mat-icon-button  color="primary" (click)="CloseDocumentViewer(CloseViewDocument)">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </div>
    </div> 
    <div class="tophead">
      <button mat-flat-button class="name" (click)="opendocdetail()">
        <mat-icon color="primary" >menu</mat-icon> Detail
      </button>
    </div>
  
    <div class="docdetail">
      <div class="left_pannel" [ngClass]="{ open: showDetail }">        
          
              <div class="info meta">
                <p><span>Doc Type</span>{{ documentName }}</p>
                <p><span>File Type</span>{{ documentType }}</p>               
                <p *ngIf="createdOn">
                  <span>Upload Date</span>{{ createdOn  | date: "MM/dd/yyyy" }}
                </p>
                <p *ngIf="createdOn">
                  <span>Created Date</span>{{ createdOn | date: "MM/dd/yyyy" }}
                </p>
              </div>         
                 
        
      </div>
  
      <div class="viewer">
        <ngx-doc-viewer
          *ngIf="
            documentType == 'doc' ||
            documentType == 'txt' ||
            documentType == 'docx' ||
            documentType == 'ppt' ||
            documentType == 'pptx' ||
            documentType == 'xlsx' ||
            documentType == 'csv' ||
            documentType == 'xls'
          "
          [url]="documentpath"
          viewer="google"
          width="100%"
          height="100%">
        </ngx-doc-viewer>
        <ngx-doc-viewer
          *ngIf="
            documentType == 'pdf' ||
            documentType != 'jpeg' ||
            documentType != 'jpg' ||
            documentType != 'png' ||
            documentType != 'gif' ||
            documentType != 'gif'"
          [url]="documentpath"
          viewer="url"
          width="100%"
          height="100%">
        </ngx-doc-viewer>
        <ngx-doc-viewer
        *ngIf="
          documentType != 'pdf' ||
          documentType == 'jpeg' ||
          documentType == 'jpg' ||
          documentType == 'png' ||
          documentType == 'gif' ||
          documentType == 'gif'"
        [url]="documentpath"
        viewer="url"
        width="100%"
        height="100%">
      </ngx-doc-viewer>
     </div>
  
      <div
        class="lefoverlay"
        (click)="opendocdetail()"
        [ngClass]="{ open: showDetail }">
      </div>
    </div>
  </mat-card>
  
  <div class="overlay" (click)="CloseDocumentViewer(CloseViewDocument)"></div>
  
 
  